import React from "react"

import "./rightworkarea.scss"

/**
 * Button to start an operation performed on an object
 * @component
 * @param  {object} props
 * @param  {string} props.icon - buttin icon
 * @param  {string} props.name - varible for run needed function
 * @param  {string} props.label - text for button
 * @param  {function} props.handler - onclick function
 * @param  {boolean} props.disabled - button state
 * @param  {object} props.style - style for button
 *
 * @example
 * const icon = ""
 * const name = ""
 * const label = ""
 * const handler = () => {}
 * const disabled = false
 * const style = {}
 *
 * return (
 *  <RightWorkBtn
 *    icon ={icon}
 *    name ={name}
 *    label ={label}
 *    handler ={handler}
 *    disabled ={disabled}
 *    style ={style}
 *  />
 * )
 */

const RightWorkBtn = props => {
  const {
    icon = "",
    name = "",
    label = "",
    handler = () => {},
    disabled = false,
    style = {},
  } = props

  return (
    <button
      className="rightWorkAreaBtn"
      onClick={handler}
      name={name}
      disabled={disabled}
      style={{...style}}
    >
      <img src={icon} alt={label} />
      <span>{label}</span>
    </button>
  )
}

export default RightWorkBtn
